import { combineReducers } from 'redux';

import { default as addressLine1 } from './addressLine1';
import { default as addressLine2 } from './addressLine2';
import { default as countryId } from './countryId';
import { default as postcode } from './postcode';
import { default as state } from './state';
import { default as suburb } from './suburb';

export default combineReducers({
  addressLine1,
  addressLine2,
  countryId,
  postcode,
  state,
  suburb,
});
